export const isPrePackUnlocked = (prePack, unlockedPrePacksMap) => () => prePack.hasBeenReplaced && !unlockedPrePacksMap.get(prePack.id) || false;
//# sourceMappingURL=isPrePackUnlocked.js.map